module.exports = __webpack_public_path__ + "static/img/7.14c1e74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/7.png
// module id = 3/9I
// module chunks = 0